module.exports = __webpack_public_path__ + "img/wave.1f3d5937.svg";